<template>
  <div id="report-issue-form">
    <v-row align="center" justify="center" v-if="isLoading">
      <RingLoader color="#7ed321" />
    </v-row>
    <v-form @submit.prevent="openConfirm" v-if="!isLoading">
      <v-row>
        <v-col cols="12">
          <template v-if="isLineChange">
            <h2 style="color: #7ed321">Username ที่ใช้เข้าเล่น</h2>
            <br />
            <v-text-field
              v-model="username"
              :error-messages="usernameErrors"
              label="กรุณาใส่ Username"
              required
              solo-inverted
              @input="$v.username.$touch()"
              @blur="$v.username.$touch()"
              :disabled="isSuccess"
              hide-details
            ></v-text-field>
            <v-row style="margin-bottom: 5px">
              <v-col cols="12" style="color: #7ed321; font-size: 12px"
                >Username
              </v-col>
            </v-row>
          </template>
          <template v-else>
            <h2 style="color: #7ed321">ชื่อ-นามสกุล</h2>
            <br />
            <v-text-field
              v-model="fullName"
              :error-messages="fullNameErrors"
              label="กรุณาใส่ชื่อ-นามสกุล"
              required
              solo-inverted
              @input="$v.fullName.$touch()"
              @blur="$v.fullName.$touch()"
              :disabled="isSuccess"
              hide-details
            ></v-text-field>
            <v-row style="margin-bottom: 5px">
              <v-col cols="12" style="color: #7ed321; font-size: 12px"
                >Full name
              </v-col>
            </v-row>
          </template>
          <h2 style="color: #7ed321">บัญชีธนาคารที่ผูกไว้</h2>
          <br />
          <v-select
            v-model="select"
            :items="itemsBankprovider"
            :error-messages="selectErrors"
            label="กรุณาเลือกธนาคาร"
            required
            solo-inverted
            return-object
            @change="$v.select.$touch()"
            @blur="$v.select.$touch()"
            :disabled="isSuccess"
            hide-details
            ><template slot="selection" slot-scope="data">
              <img width="20px" class="mr-2" :src="data.item.logo" />
              {{ data.item.name }}
              ({{ data.item.shortname }})
            </template>
            <template slot="item" slot-scope="data">
              <img width="30px" class="mr-2" :src="data.item.logo" />
              {{ data.item.name }}
              ({{ data.item.shortname }})
            </template></v-select
          >
          <v-row style="margin-bottom: 5px">
            <v-col cols="12" style="color: #7ed321; font-size: 12px"
              >Bank account
            </v-col>
          </v-row>
          <v-text-field
            v-if="select"
            v-model="bankAcc"
            :error-messages="bankAccErrors"
            :rules="[bankAccountRule(bankAcc, select)]"
            label="กรุณาใส่เลขบัญชี"
            required
            solo-inverted
            @input="$v.bankAcc.$touch()"
            @blur="$v.bankAcc.$touch()"
            :disabled="isSuccess"
            hide-details
          ></v-text-field>
          <v-row v-if="select" style="margin-bottom: 5px">
            <v-col cols="12" style="color: #7ed321; font-size: 12px"
              >Account number
            </v-col>
          </v-row>
          <template v-if="isLineChange">
            <h2 style="color: #7ed321">ชื่อ LINE เดิม</h2>
            <br />
            <v-text-field
              v-model="oldLineName"
              label="ชื่อที่แสดงใน LINE เดิม (ถ้าทราบ)"
              solo-inverted
              :disabled="isSuccess"
              hide-details
            ></v-text-field>
            <v-row style="margin-bottom: 5px">
              <v-col cols="12" style="color: #7ed321; font-size: 12px"
                >Old LINE name
              </v-col>
            </v-row>
          </template>
          <h2 style="color: #7ed321">เบอร์ติดต่อ</h2>
          <br />
          <v-text-field
            v-model="phone"
            type="tel"
            :error-messages="phoneErrors"
            label="เบอร์โทรที่ติดต่อได้ (ถ้ามี)"
            solo-inverted
            @input="$v.phone.$touch()"
            @blur="$v.phone.$touch()"
            :disabled="isSuccess"
            hide-details
          ></v-text-field>
          <v-row style="margin-bottom: 5px">
            <v-col cols="12" style="color: #7ed321; font-size: 12px"
              >Phone
            </v-col>
          </v-row>
          <h2 style="color: #7ed321">
            {{ isLineChange ? "หมายเหตุ" : "อาการ / ปัญหาที่พบ" }}
          </h2>
          <br />
          <v-textarea
            v-model="note"
            :error-messages="noteErrors"
            :label="
              isLineChange
                ? 'รายละเอียดเพิ่มเติม (ถ้ามี)'
                : 'กรุณาอธิบายปัญหาที่พบตอนสมัคร'
            "
            rows="3"
            counter="200"
            maxlength="200"
            solo-inverted
            @input="$v.note.$touch()"
            @blur="$v.note.$touch()"
            :disabled="isSuccess"
          ></v-textarea>
          <v-btn
            block
            elevation="2"
            x-large
            type="submit"
            :style="!$v.$invalid ? 'background-color: #7ed321' : ''"
            :disabled="$v.$invalid || isSuccess"
          >
            ส่งเรื่อง
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
    <v-dialog v-model="confirmDialog" max-width="400">
      <v-card>
        <v-card-title>ยืนยันการส่งเรื่อง</v-card-title>
        <v-card-text>
          {{
            isLineChange
              ? "ยืนยันการแจ้งขอเปลี่ยน user LINE ระบบจะส่งข้อมูล LINE ที่คุณใช้อยู่ตอนนี้ให้เจ้าหน้าที่"
              : "ยืนยันการแจ้งปัญหาสมัครบัญชีไม่ได้"
          }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="confirmDialog = false">ยกเลิก</v-btn>
          <v-btn color="#7ed321" text @click="submit">ยืนยัน</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, maxLength, helpers } from "vuelidate/lib/validators";
import liff from "@line/liff";
import { RingLoader } from "vue-spinners-css";
import issueService from "../../services/issue_service.js";
import { BANK_PROVIDERS, bankAccountRule } from "../../config/banks.js";

const phonePattern = helpers.regex("phonePattern", /^0\d{8,9}$/);

export default {
  name: "ReportIssueForm",
  components: {
    RingLoader,
  },
  mixins: [validationMixin],
  props: {
    topic: {
      type: String,
      required: true,
      validator: (value) => ["line_change", "register_issue"].includes(value),
    },
    lineId: {
      type: String,
      default: "",
    },
    displayName: {
      type: String,
      default: "",
    },
  },
  validations() {
    const base = {
      select: { required },
      bankAcc: { required },
      phone: { phonePattern },
      note: { maxLength: maxLength(200) },
      username: {},
      fullName: {},
    };
    if (this.isLineChange) {
      return {
        ...base,
        username: { required },
      };
    }
    return {
      ...base,
      fullName: { required },
      note: { required, maxLength: maxLength(200) },
    };
  },
  data: () => ({
    username: "",
    fullName: "",
    select: null,
    bankAcc: "",
    oldLineName: "",
    phone: "",
    note: "",
    itemsBankprovider: BANK_PROVIDERS,
    bankAccountRule,
    confirmDialog: false,
    isLoading: false,
    isSuccess: false,
  }),
  computed: {
    isLineChange() {
      return this.topic === "line_change";
    },
    usernameErrors() {
      const errors = [];
      if (!this.$v.username.$dirty) return errors;
      this.isLineChange &&
        !this.$v.username.required &&
        errors.push("กรุณาใส่ Username");
      return errors;
    },
    fullNameErrors() {
      const errors = [];
      if (!this.$v.fullName.$dirty) return errors;
      !this.isLineChange &&
        !this.$v.fullName.required &&
        errors.push("กรุณาใส่ชื่อ-นามสกุล");
      return errors;
    },
    selectErrors() {
      const errors = [];
      if (!this.$v.select.$dirty) return errors;
      !this.$v.select.required && errors.push("กรุณาเลือกธนาคาร");
      return errors;
    },
    bankAccErrors() {
      const errors = [];
      if (!this.$v.bankAcc.$dirty) return errors;
      !this.$v.bankAcc.required && errors.push("กรุณาใส่เลขบัญชี");
      return errors;
    },
    phoneErrors() {
      const errors = [];
      if (!this.$v.phone.$dirty) return errors;
      !this.$v.phone.phonePattern &&
        errors.push("กรุณากรอกเบอร์โทรให้ถูกต้อง");
      return errors;
    },
    noteErrors() {
      const errors = [];
      if (!this.$v.note.$dirty) return errors;
      !this.isLineChange &&
        !this.$v.note.required &&
        errors.push("กรุณาอธิบายปัญหาที่พบ");
      !this.$v.note.maxLength && errors.push("ไม่เกิน 200 ตัวอักษร");
      return errors;
    },
  },
  methods: {
    openConfirm() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      this.confirmDialog = true;
    },
    submit() {
      this.confirmDialog = false;
      this.isLoading = true;
      const body = {
        topic: this.topic,
        username: this.username,
        fullName: this.fullName,
        bankName: this.select ? this.select.shortname : "",
        accountNo: this.bankAcc,
        oldLineName: this.oldLineName,
        phone: this.phone,
        note: this.note,
        lineId: this.lineId,
        lineDisplayName: this.displayName,
      };
      issueService
        .reportIssue(body)
        .then((res) => {
          this.isSuccess = true;
          this.isLoading = false;
          this.$toast.success(res.data.displayMessage || res.data.message, {
            position: "top-center",
            timeout: 5000,
            closeOnClick: true,
            pauseOnFocusLoss: true,
            pauseOnHover: true,
            draggable: true,
            draggablePercent: 0.6,
            showCloseButtonOnHover: false,
            hideProgressBar: false,
            closeButton: "button",
            icon: true,
            rtl: false,
          });
          setTimeout(() => {
            liff.closeWindow();
          }, 2000);
        })
        .catch((error) => {
          this.isLoading = false;
          this.$toast.error(
            error.response && error.response.data
              ? error.response.data.display_message ||
                  error.response.data.displayMessage
              : "เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง",
            {
              position: "top-center",
              timeout: 5000,
              closeOnClick: true,
              pauseOnFocusLoss: true,
              pauseOnHover: true,
              draggable: true,
              draggablePercent: 0.6,
              showCloseButtonOnHover: false,
              hideProgressBar: false,
              closeButton: "button",
              icon: true,
              rtl: false,
            }
          );
        });
    },
  },
};
</script>
